import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

export interface IPrevNextIconButtons {
  onNext?: () => void;
  onPrevious?: () => void;
  nextLabel?: string;
  previousLabel?: string;
  complete?: boolean;
}

const PrevNextIconButtons = (props: IPrevNextIconButtons) => {
  const { onNext, onPrevious, nextLabel, previousLabel, complete } = props;

  return (
    <>
      <Flex ml="auto" gap={1}>
        {onPrevious ? (
          <Tooltip hasArrow label={previousLabel || 'Previous page'}>
            <IconButton
              onClick={onPrevious}
              aria-label={previousLabel || 'Previous page'}
              icon={<FontAwesomeIcon icon={faChevronLeft} size="lg" />}
              variant="ghost"
              size="lg"
              colorScheme="gray"
              borderRadius="full"
            />
          </Tooltip>
        ) : null}
        {onNext ? (
          <Tooltip hasArrow label={nextLabel || 'Start section'}>
            <IconButton
              onClick={onNext}
              aria-label={nextLabel || 'Start section'}
              isDisabled={complete ? false : true}
              icon={<FontAwesomeIcon icon={faChevronRight} size="lg" />}
              variant="ghost"
              size="lg"
              colorScheme="gray"
              borderRadius="full"
            />
          </Tooltip>
        ) : null}
      </Flex>
    </>
  );
};

export default PrevNextIconButtons;
